<template>
  <div class="animated fadeIn" id="data">
    <b-row>
      <b-col sm="12">
        <b-card
          class="full-width"
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <strong v-if="$route.name !== 'ViewAttribute'"
              >{{ concern[context] }} Attribute</strong
            >
            <strong v-else>View Attribute</strong>
          </div>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="name">Field Name</label>
                <b-form-input
                  type="text"
                  id="name"
                  v-model="inputObj.attributeName"
                  placeholder="Enter Field Name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="month1">Type</label>
                <b-form-select
                  id="option"
                  v-model="inputObj.attributeValueType"
                  :options="options"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="ccnumber">Description</label>
                <b-form-input
                  type="text"
                  id="description"
                  v-model="inputObj.description"
                  placeholder="Short Description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <v-select
                v-model="selectedLanguage"
                @change="onChangeLang"
                :items="languages"
                item-text="name"
                return-object
                label="Select Language"
                multiple
                chips
                hint="What are the target language"
                persistent-hint
              ></v-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="4"
              v-for="(item, index) in selectedLanguage"
              :key="index"
            >
              <b-form-group>
                <label :for="item.name">Field Label {{ item.name }}</label>
                <b-form-input
                  type="text"
                  :id="item.name"
                  v-model="inputObj.attributeLabel[item.id]"
                  :placeholder="`Enter Field Label in ${item.name}`"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="flex">
            <div class="form-actions">
              <eb-button
                v-if="$route.name !== 'ViewAttribute'"
                classic="mr-1 btn-primary"
                text="Save"
                @click="handleSubmit"
                icon="fas fa-save mr-1"
                iconSide="left"
              ></eb-button>

              <router-link to="/attribute">
                <eb-button
                  classic="mr-1 btn-primary"
                  text="Cancel"
                  icon="fas fa-arrow-alt-circle-left mr-1"
                  iconSide="left"
                ></eb-button>
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="isArrayType">
      <b-col sm="12">
        <array
          title="Array Field"
          :type="arrayType"
          :currentroute="$route.name"
          :types="types"
          @changeType="changeArrayType"
          @add="addArrayItem"
          @delete="deleteArrayItem"
          :items="arrayItems"
          :objectType="isArrayOfObject"
        />
      </b-col>
    </b-row>

    <b-row v-if="complexType || isArrayOfObject">
      <b-col sm="12">
        <attr-form
          :title="inputObj.attributeName"
          :inputObj="objectSpec"
          :typeOptions="subOptions"
          :inputMethods="{
            changeType: this.changeType,
            changeName: this.changeName,
            changeDesc: this.changeDesc
          }"
          :nameError="$v.objectSpec.attributeName.$error"
        >
          <template v-slot:actions>
            <eb-button
              classic="mr-1 btn-primary"
              text="Add"
              @click="saveInner"
              icon="fa fa-plus-circle mr-1"
              iconSide="left"
            ></eb-button>
            <eb-button
              classic="mr-1 btn-primary"
              text="Reset"
              @click="resetInner"
              icon="fas fa-retweet mr-1"
              iconSide="left"
            ></eb-button>
          </template>

          <template v-slot:members>
            <b-card
              class="card-accent-info"
              header="Sub Attributes"
              border-variant="info"
              header-bg-variant="primary"
              header-text-variant="white"
            >
              <div v-show="objectMembers.length > 0">
                <b-form-group label-cols-sm="3" class="mb-2">
                  <b-input-group>
                    <b-form-input
                      v-model="filter"
                      placeholder="Type to Search"
                    />
                    <!-- <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''" class="btn btn-primary">Clear</b-button>
                    </b-input-group-append>-->
                  </b-input-group>
                </b-form-group>
                <b-table
                  :items="objectMembers"
                  :fields="objectColumns"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :bordered="true"
                  thead-class="header"
                >
                  <template slot="action" slot-scope="data">
                    <b-button
                      size="sm"
                      class="mr-2"
                      variant="danger"
                      @click="deleteAttribute(data)"
                    >
                      <i class="fa fa-trash bin"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      class="mr-2"
                      variant="primary"
                      @click="editAttribute(data)"
                    >
                      <i class="fa fa-pencil edit"></i>
                    </b-button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                  />
                </nav>
              </div>
              <b-row v-if="!objectMembers.length > 0">
                <b-col md="12 mt-2">
                  <b-alert
                    v-model="showDismissibleAlert"
                    variant="info"
                    dismissible
                    >Data Not Found</b-alert
                  >
                </b-col>
              </b-row>
            </b-card>
          </template>
        </attr-form>
      </b-col>
    </b-row>

    <!-- <b-card
      class="card-accent-info"
      header="Actions"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
      v-if="$route.name !== 'ViewAttribute'"
    > -->
    <!-- <div class="flex">
        <div class="form-actions">
          <eb-button
            classic="mr-1 btn-primary"
            text="Save"
            @click="handleSubmit"
            icon="fas fa-save mr-1"
            iconSide="left"
          ></eb-button>

          <router-link to="/attribute">
            <eb-button
              classic="mr-1 btn-primary"
              text="Cancel"
              icon="fas fa-arrow-alt-circle-left mr-1"
              iconSide="left"
            ></eb-button>
          </router-link>
        </div>
      </div> -->
    <!-- </b-card> -->
    <br />
  </div>
</template>

<style scoped>
.flex {
  display: flex;
  flex-direction: row-reverse;
}
.form-actions {
  width: max-content;
}
</style>

<script>
import axios from "axios";
import { required, minLength, between } from "vuelidate/lib/validators";
import { createAttibute, update, findByid } from "../../services/attribute.js";
import ArrayForm from "@/components/Attribute/Array";
import AttributeForm from "@/components/Attribute/AttributeForm";
import ebButton from "@/components/FormElements/Button";
let { isArray } = Array;

let initState = function() {
  return {
    langObj: {
      en: "English",
      bn: "Bengali",
      te: "Telugu",
      hi: "Hindi"
    },
    showDismissibleAlert: true,
    selected: [], // Must be an array reference!
    show: true,
    filter: "",
    inputObj: {
      attributeName: "",
      description: "",
      attributeValueType: "String",
      attributeLabel: {}
    },
    selectedLanguage: [],
    languages: [
      { id: "en", name: "English" },
      { id: "bn", name: "Bengali" },
      { id: "te", name: "Telugu" },
      { id: "hi", name: "Hindi" }
    ],
    objectSpec: {
      attributeName: "",
      description: "",
      attributeValueType: "String"
    },
    concern: {
      edit: "Edit",
      create: "Create",
      view: "View"
    },
    options: [
      {
        value: "Object",
        text: "Object"
      },
      {
        value: "Array",
        text: "Array"
      },
      {
        value: "String",
        text: "String"
      },
      {
        value: "Number",
        text: "Number"
      },
      {
        value: "Boolean",
        text: "Boolean"
      },
      {
        value: "Image",
        text: "Image"
      }
    ],
    subOptions: [
      {
        value: "String",
        text: "String"
      },
      {
        value: "Number",
        text: "Number"
      },
      {
        value: "Boolean",
        text: "Boolean"
      }
    ],
    objectMemberIndex: null,
    objectMembers: [],
    currentPage: 1,
    perPage: 10,
    objectColumns: [
      {
        key: "attributeName",
        label: "Field Name",
        sortable: true
      },
      {
        key: "attributeValueType",
        label: "Type",
        sortable: true
      },
      {
        key: "description",
        label: "Description",
        sortable: true
      },
      {
        key: "action",
        label: "Action"
      }
    ],
    arrayType: "Checkbox",
    types: ["Checkbox", "Select", "Radio", "Object"],
    arrayItems: []
  };
};

export default {
  name: "createattibute",
  data() {
    return initState();
  },
  validations: {
    objectSpec: {
      attributeName: {
        required,
        minLength: minLength(2)
      }
    }
  },
  computed: {
    complexType: function() {
      return ["Object"].includes(this.inputObj.attributeValueType);
    },
    isArrayType: function() {
      return this.inputObj.attributeValueType === "Array";
    },
    isArrayOfObject: function() {
      return (
        this.inputObj.attributeValueType === "Array" &&
        this.arrayType === "Object"
      );
    },
    context: function() {
      return this.$route.params &&
        this.$route.params.id &&
        this.$route.params.id.length === 24
        ? "edit"
        : "create";
    },
    totalRows: function() {
      return this.objectMembers.length;
    },
    objectMembersSet: function() {
      return new Set(
        this.objectMembers ? this.objectMembers.map(o => o.attributeName) : []
      );
    },
    arrayItemsSet: function() {
      return new Set(this.arrayItems.map(i => i.name));
    }
  },
  methods: {
    async handleSubmit() {
      if (this.inputObj.attributeLabel.en === "") {
        this.inputObj.attributeLabel.en = this.inputObj.attributeName;
      }
      console.log(this.inputObj);
      let payload = {
        ...this.inputObj,
        attributeItems: this.objectMembers
      };
      // filter Label object with selected Lang.
      if (this.selectedLanguage.length > 0) {
        let keys = Object.keys(this.inputObj.attributeLabel);
        keys.map(key => {
          const ifKeyExist = this.selectedLanguage.some(obj => obj.id === key);
          if (!ifKeyExist) {
            delete this.inputObj.attributeLabel[key];
          }
        });
      }
      if (this.isArrayType === true) {
        payload.attributeValueType = "Array";
        payload.UIConcern = this.arrayType;
        if (["Checkbox", "Select", "Radio"].includes(this.arrayType))
          payload.attributeItems = this.arrayItems.map(a => ({
            attributeName: a.name
          }));
      }
      console.log("this is payload : ", payload);
      if (this.context === "create") {
        await this.$store
          .dispatch("attribute/createAttribute", payload)
          .then(result => {
            if (result.status === 1) {
              this.$swal({
                title: "Congratulation",
                text: "Attribute has been created Successfully",
                type: "success"
              });
              this.reset();
              this.$router.push({ path: "/attribute" });
            }
          })
          .catch(error => {
            this.$swal({
              title: "Oops",
              text: "Attribute has not been saved",
              type: "error"
            });
          });
      } else {
        delete payload._id, delete payload.createdBy;
        delete payload.createdAt;
        delete payload.updatedAt;
        delete payload.__v;
        const payloadObj = { id: this.$route.params.id, data: payload };
        console.log(payload);
        this.$store
          .dispatch("attribute/updateAttribute", payloadObj)
          .then(result => {
            if (result.status === 1) {
              this.$swal({
                title: "Congratulation",
                text: "Attribute has been updated Successfully",
                type: "success"
              });
              this.$router.push({ path: "/attribute" });
            }
          })
          .catch(error => {
            this.$swal({
              title: "Oops",
              text: "Attribute has not been saved",
              type: "error"
            });
          });
      }
    },
    changeSimple(path, value) {
      this.inputObj[path] = value;
    },
    changeInner(path, value) {
      this.objectSpec[path] = value;
    },
    changeName(e) {
      console.log("change : ", e);
      this.changeInner("attributeName", e);
      this.$v.objectSpec.attributeName.$touch();
    },
    changeType(e) {
      this.changeInner("attributeValueType", e);
    },
    changeDesc(e) {
      this.changeInner("description", e);
    },
    saveInner() {
      console.log("already set : ", this.objectMembersSet);
      if (this.$v.$invalid) return;

      let freshMember = { ...this.objectSpec };
      console.log("index : ", this.objectMemberIndex);
      if (this.objectMemberIndex !== null) {
        console.log("edit member");
        this.objectMembers = this.objectMembers.map((m, idx) =>
          idx == this.objectMemberIndex ? freshMember : m
        );
      } else {
        console.log("add member");
        if (this.objectMembersSet.has(this.objectSpec.attributeName)) {
          this.$message.error("The field already exists!!");
          return;
        }
        this.objectMembers = this.objectMembers.concat([freshMember]);
      }
      console.log("members : ", this.objectMembers);
      this.resetInner();
    },
    reset() {
      Object.assign(this.$data, initState());
    },
    resetInner() {
      this.objectSpec = {
        attributeName: "",
        description: "",
        attributeValueType: "String"
      };
      this.objectMemberIndex = null;
    },
    deleteAttribute(data) {
      console.log("got data : ", data);
      let { index } = data;
      this.objectMembers = this.objectMembers.filter((m, idx) => idx !== index);
    },
    editAttribute(data) {
      console.log("in edit");

      console.log("got data : ", data);
      this.objectSpec = this.objectMembers[data.index];
      this.objectMemberIndex = data.index;
    },
    changeArrayType(e) {
      console.log("change the type : ", e);
      this.arrayType = e;
    },
    addArrayItem(e) {
      if (!(e && e.name && e.name.length > 1)) return;
      if (this.arrayItemsSet.has(e.name)) {
        this.$message.error("The field already exists!!");
        return;
      }
      console.log(
        "add item parent : ",
        e,
        "already : ",
        this.arrayItemsSet.has(e.name)
      );
      this.arrayItems.push({ ...e });
    },
    deleteArrayItem(e) {
      this.arrayItems.splice(e, 1);
    },
    onChangeLang(event) {
      console.log(this.selectedLanguage);
    }
  },
  async mounted() {
    if (this.context === "edit") {
      await this.$store
        .dispatch("attribute/getAttributeById", this.$route.params.id)
        .catch(error => {
          this.$toasted.error(error);
        });
      let result = this.$store.getters["attribute/GetCurrentReadAttribute"];
      console.log("getter result", result);
      let { attributeItems, UIConcern, attributeValueType } = result;
      if (attributeValueType === "Array") {
        this.arrayItems = isArray(attributeItems)
          ? result.attributeItems.map(i => ({ name: i.attributeName }))
          : [];
      } else if (attributeValueType === "Object") {
        this.objectMembers = isArray(attributeItems) ? attributeItems : [];
      }
      this.inputObj = result;
      if (!this.inputObj.attributeLabel) {
        this.inputObj.attributeLabel = {
          en: "",
          bn: "",
          te: ""
        };
      } else {
        Object.keys(this.inputObj.attributeLabel).map(obj => {
          this.selectedLanguage.push({
            id: obj,
            name: this.langObj[obj]
          });
        });
      }
      console.log("ree", result);
    }
  },
  components: {
    "attr-form": AttributeForm,
    array: ArrayForm,
    ebButton
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
<style>
.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: #727cf5 !important;
  border-color: #727cf5 !important;
  color: #fff;
}
</style>
